module.exports = __webpack_public_path__ + "static/bigPillMobile-4a2a7b48e8132fa18d683c69daee6a7f.png";